import toast, { ToastOptions } from 'react-hot-toast'
import { Alert, AlertProps, AlertColor } from '@mui/material'

export function createToast(
  message: string,
  severity: AlertColor,
  alertProps: AlertProps = {},
  toastOptions: ToastOptions = {},
) {
  return toast(
    (t) => (
      <Alert onClose={() => toast.dismiss(t.id)} severity={severity} elevation={6} variant="filled" {...alertProps}>
        {message}
      </Alert>
    ),
    { style: { padding: 0 }, ...toastOptions },
  )
}
